import { intl } from '@approvalmax/utils';
import { FC } from 'react';

import DearLineTable from '../DearLineTable/DearLineTable';
import { messages } from './DearItemLines.messages';
import { NoWrapCell } from './DearItemLines.styles';
import { DearItemLineColumnDefinition, DearItemLinesProps } from './DearItemLines.types';

const columnDefs: DearItemLineColumnDefinition[] = [
    {
        id: 'product',
        name: messages.columnProduct,
        value: (li) => (li.product ? li.product.displayName : null),
        minWidth: 100,
    },
    {
        id: 'comment',
        name: messages.columnComment,
        value: (li) => li.comment,
        minWidth: 210,
    },
    {
        id: 'supplierSku',
        name: messages.columnSupplierSku,
        value: (li) => li.supplierSku,
        minWidth: 100,
    },
    {
        id: 'quantity',
        name: messages.columnQuantity,
        value: (li) => intl.formatNumber(li.quantity || 0, 'inherit', true),
        alignRight: true,
        cell: (value) => <NoWrapCell>{value}</NoWrapCell>,
    },
    {
        id: 'price',
        name: messages.columnPrice,
        value: (li) => intl.formatNumber(li.price || 0, 'inherit', true),
        alignRight: true,
        cell: (value) => <NoWrapCell>{value}</NoWrapCell>,
    },
    {
        id: 'discount',
        name: messages.columnDiscount,
        value: (li) => (li.discount ? `${li.discount}%` : null),
        alignRight: true,
        cell: (value) => <NoWrapCell>{value}</NoWrapCell>,
    },
    {
        id: 'taxRule',
        name: messages.columnTaxRule,
        value: (li) => li.taxRule,
        alignRight: true,
        cell: (value) => <NoWrapCell>{value}</NoWrapCell>,
    },
    {
        id: 'total',
        name: messages.columnTotal,
        value: (li) => intl.formatNumber(li.total || 0, 'auto'),
        alignRight: true,
        cell: (value) => <NoWrapCell>{value}</NoWrapCell>,
    },
];

const DearItemLines: FC<DearItemLinesProps> = (props) => {
    const { itemLines } = props;

    return itemLines.length > 0 ? (
        <DearLineTable title={messages.sectionHeaderText} columnDefinitions={columnDefs} lineItems={itemLines} />
    ) : null;
};

export default DearItemLines;
